import React, { FC, ButtonHTMLAttributes } from 'react';
import styles from './NextButton.module.css';

export type NextButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

const NextButton: FC<NextButtonProps> = ({ children, disabled, ...props }) => (
  <button
    className={styles.button}
    disabled={disabled}
    {...props}
  >
    {children}
  </button>
);

export default NextButton;